import Vue from 'vue'
import {
  decode,
  slug,
  formatPrice,
  generateSrcset
} from 'utils/general'
/**
 * Stockists Component
 */
Vue.component('stockists', {
  props: [
    'stockistsJson'
  ],
  data () {
    return {
      selectedCountry: '',
      selectedCategory: ''
    }
  },
  computed: {
    countries () {
      const countries = this.stockistsJson.map((data) => {
        return (data && data['country_name'])
      })

      return this.getUnique(countries)
    },
    categories () {
      const categories = this.stockistsJson.map((data) => {
        return (data && (data.category || data.cateogry))
      })

      return this.getUnique(categories)
    },
    storeItems () {
      var items = this.stockistsJson

      if (this.selectedCountry) {
        items = items.filter((data) => {
          return (data && data['country_name'] && (data['country_name'] === this.selectedCountry))
        })
      }

      if (this.selectedCategory) {
        items = items.filter((data) => {
          const category = data && (data.category || data.cateogry)
          return (category && (category === this.selectedCategory))
        })
      }

      return items
    }
  },
  methods: {
    initData () {
      if (this.stockistsJson) {
        this.stockistsJson.forEach((item, index) => {
          this.stockistsJson[index].visible = true
        })
      }
    },
    getUnique (data) {
      if (data) {
        return [...new Set(data)]
      } else {
        return []
      }
    },
    getLabel (text) {
      return text.charAt(0)
    }
  },
  mounted () {
    this.initData()

    const country = this.stockistsJson.map((data) => {
      return (data && data['country_name'])
    })

    if (country) {
      const filteredCountries = this.getUnique(country)
      this.selectedCountry = filteredCountries[0]
    }
  }
})
